export const ICONS = ['Crest', 'CrownLogoQueen', 'CrownLogo', 'Search'] as const
